import Icon from '../components/Icon'

Icon.register({
  crosshairs: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500 224c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-30.4c-13.9 93.7-88 167.7-181.6 181.6v30.4c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-30.4c-93.7-13.9-167.7-88-181.6-181.6h-30.4c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h30.4c13.9-93.7 88-167.7 181.6-181.6v-30.4c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v30.4c93.7 13.9 167.7 88 181.6 181.6h30.4zM288 404.6c58.2-12.4 104.2-58.5 116.6-116.6h-40.6c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40.6c-12.4-58.2-58.5-104.2-116.6-116.6v40.6c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40.6c-58.2 12.4-104.2 58.5-116.6 116.6h40.6c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40.6c12.4 58.2 58.5 104.2 116.6 116.6v-40.6c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40.6zM288 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32z'
      }
    ]
  }
})
